import axios from "axios";

export const API = axios.create({
  // baseURL: "https://data.gune.kr.s3.amazonaws.com/", // 기존
  // baseURL: "http://data.gune.kr.s3-website.ap-northeast-2.amazonaws.com/", // 웹으로 수정
  // baseURL: "https://gune.kr/data/", // 리다이렉트용
  baseURL: "https://s3.ap-northeast-2.amazonaws.com/data.gune.kr/", // 리다이렉트용
  timeout: 20000,
  headers: {
    "Cache-Control": "no-cache",
  },
});

export function S3Service() {
  delete API.defaults.headers.common["Authorization"];
  return API;
}
